import { useRef } from 'react';
import { Control } from 'react-hook-form';

import { BindingCreator } from '@dreryk/react-common';
import { DatePickerLegacy } from '@dreryk/react-components';

import { DateFilter } from '../../../AppointmentsFilterChips/DateChipFilter.types';
import { getToday } from '../../../AppointmentsFilterChips/DateChipFilter.utils';
import { FilterFormBean } from '../../AppointmentsFilterPanel';

import { useUpdateUrlFromDatePicker } from './DatePickerField.hooks';

type DatePickerFieldType = {
   readonly register: BindingCreator<FilterFormBean>;
   readonly control: Control<FilterFormBean>;
   readonly dateFilterValue: DateFilter['range'] | undefined;
};

const DatePickerField = (props: DatePickerFieldType): JSX.Element => {
   const defaultDate = useRef(props.dateFilterValue?.lowerEndpoint() ?? getToday());
   useUpdateUrlFromDatePicker(props.control, defaultDate.current);
   const controller = props.register(DatePickerField.fieldName);

   return (
      <DatePickerLegacy
         controller={controller}
         horizontal
         withNavigationArrows
         defaultValue={defaultDate.current}
         testId={'date'}
      />
   );
};
DatePickerField.fieldName = 'date.day' as const;
DatePickerField.displayName = 'AppointmentFilterDatePickerField';

export { DatePickerField };
